import React from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import * as actions from "../../../store/requests/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  //const { rejectionReasons } = useSelector((state) => state.requests);
  //const [rejectionReasonsOptions, setRejectionReasonsOptions] = useState([]);
  const payload = { page: 1, requestStatus: 8, sort: "created_at,desc" };
  const stages = [
    {id: 0, name: messages.requests.stages.all_stages},
   
    {id: 1, name: messages.requests.stages.new_requests},
    {id: 7, name: messages.requests.stages.rejected},
    {id: 2, name: messages.requests.stages.not_completed},
    {id: 3, name: messages.requests.stages.appointment_reservation},
    {id: 4, name: messages.requests.stages.interview},
    {id: 14, name: messages.requests.stages.no_interview},
    {id: 13, name: messages.requests.stages.obligation_sending},
    {id: 15, name: messages.requests.stages.obligation_no_sent},
  ]
  /*
  // Get Rejection Reasons 
  useEffect(() => {
    dispatch(actions.rejectionReasonsRequest());
    return () => {
      dispatch(actions.rejectionReasonsReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    //add all option
    if (rejectionReasons)
      setRejectionReasonsOptions([
        { id: 0, title: messages.requests.all_reasons },
        ...rejectionReasons,
      ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rejectionReasons]);
  */


  const initialValues = {
    search: "",
    previousStatus: 0,
    rejectionReasonId: 0,
  };

  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    previousStatus: Yup.object().nullable(),
    rejectionReasonId: Yup.object().nullable(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });

  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: e.target.value, previousStatus: formik.values.previousStatus, rejectionReasonId: formik.values.rejectionReasonId });
    dispatch(
      actions?.canceledRequestsRequest({
        ...payload,
        ...formik.values,
        search: e.target.value,
      })
    );
  };
  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, previousStatus: e.target.value, rejectionReasonId: formik.values.rejectionReasonId });
    dispatch(
      actions?.canceledRequestsRequest({
        ...payload,
        ...formik.values,
        previousStatus: e.target.value,
      })
    );
  };
  /* const searchWithReason = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, previousStatus: formik.values.previousStatus, rejectionReasonId: e.target.value });
    dispatch(
      actions?.canceledRequestsRequest({
        ...payload,
        ...formik.values,
        rejectionReasonId: e.target.value,
      })
    );
  }; */
   
  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.requests.search_by_phone_or_name_or_id_placholder}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="previousStatus"
              list={stages}
              keyName="name"
              valueKeyName="id"
              value={formik.values.previousStatus}
              handleChange={(e) => searchWithSelect(e, "previousStatus")}
              error={formik.errors.previousStatus}
            />
          </div>
          {/* <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="rejectionReasonId"
              list={rejectionReasonsOptions}
              keyName="title"
              valueKeyName="id"
              value={formik.values.rejectionReasonId}
              handleChange={(e) => searchWithReason(e, "rejectionReasonId")}
              error={formik.errors.rejectionReasonId}
            />
          </div> */}
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
